// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1C3NB","right":"Footer_right__9AW1I","buttons":"Footer_buttons__21PLm"};